class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");
    this.cartErrors = document.getElementById('cart-errors');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
  
    this.addEventListener('change', this.debouncedOnChange.bind(this));
    console.log("debouncedOnChange called line ~29");

    this.addEventListener('change', (event) => {
      if (event.target === null) return;
    
      if (event.target.getAttribute('name') === 'updates[]') {
        this.updateQuantity(event.target.dataset.index, event.target.value, 'updates[]');
      } 
    });
  
    this.addEventListener('click', this.onSubButtonClick.bind(this));
  }

  // cartUpdateUnsubscriber = undefined;

  // connectedCallback() {
  //   this.cartUpdateUnsubscriber = subscribe(
  //     PUB_SUB_EVENTS.cartUpdate,
  //     (event) => {
  //       if (event.source === "cart-items") {
  //         return;
  //       }
  //       this.onCartUpdate();
  //     }
  //   );
  // }

  // disconnectedCallback() {
  //   if (this.cartUpdateUnsubscriber) {
  //     this.cartUpdateUnsubscriber();
  //   }
  // }

  onChange(event) {
    if (event.target === null) return;
    if (event.target.getAttribute('name') === 'updates[]') {
      this.updateQuantity(event.target.dataset.index, event.target.value, 'updates[]');
    } 
  }

  onCartUpdate() {
    console.log("Oncartupdate function called");
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${theme.routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${theme.routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart')?.id,
        selector: '.shopify-section',
      },
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${theme.routes.cartChange}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);

        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          if (parsedState.sections[section.section]) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;

        // get items still in cart to update cart bubble
        const cartDrawerItems = document.querySelectorAll(
          "#CartDrawer-CartItems .cart-items .cart-item"
        );

        // update the top nav cart bubble if there are still items left in cart
        if (cartDrawerItems.length === 0) {
          const cartIconBubbleContainer = document.getElementById(
            `cart-icon-bubble-container`
          );
          cartIconBubbleContainer.style.display = "none";
          // else update cart bubble
        } else {
          const cartIconBubbleItemCount = document.getElementById(
            `cart-icon-bubble-item-count`
          );
          cartIconBubbleItemCount.innerHTML = cartDrawerItems.length;
        }

        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");

        // @todo: figure out why this entire catch block is getting triggered?
        //errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  async replaceCartItem(key, quantity) {
    //this.enableLoading(line);
    console.log("replaceCartItem function called");
    const sections = this.getSectionsToRender().map(
      (section) => section.section
    );

    const body = JSON.stringify({
      id: key,
      quantity,
      sections: sections,
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(`${theme.routes.cartChange}`, { ...fetchConfig(), ...{ body } });
      const parsedState = response.json();
      return parsedState;
    } catch (e) {
      this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
      this.disableLoading();
      if (this.cartErrors) {
        this.cartErrors.textContent = window.cartStrings.error;
      }
    }
  }

  onSubButtonClick(event) {
    if (event.target.classList.contains("add-selling-plan__button")) {
      const subSelect = event.target;
      const sellingPlan = subSelect.getAttribute("data-selling-plan");
      const line = subSelect.getAttribute("data-index");
      const freeGiftVariantId = subSelect.getAttribute(
        "data-free-gift-variant-id"
      );
      const variantId = subSelect.getAttribute("data-variant-id");

      this.handleSubSelection(subSelect);
      this.updateSellingPlan(line, variantId, sellingPlan, freeGiftVariantId);
    }
  }

  handleSubSelection(line, sellingPlan) {
    console.log("handleSubSelection function called");
    //const attribute =  event.target.querySelector.('add-selling-plan__button').getAttribute('name');

    document.querySelectorAll(`add-selling-plan__button`).forEach((button) => {
      console.log("button attribute found");
      button.setAttribute(
        "data-selling-plan",
        subSelect.getAttribute("data-selling-plan")
      );
    });
    console.log("sellingPlan original:", sellingPlan);
  }

  updateSellingPlan(line, variantId, sellingPlan, freeGiftVariantId) {
    //console.log('updateSellingPlan function called');
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map(
      (section) => section.section
    );

    // Check if the selling_plan property is null before updating it
    if (sellingPlan === null) {
      sellingPlan = sellingPlan;
    }
    console.log("sellingPlan updated:", sellingPlan);

    let cartItem = {
      line: line,
      id: variantId,
      quantity: 1,
      selling_plan: sellingPlan,
      sections: sections,
      sections_url: window.location.pathname,
    };

    //console.log(body);

    fetch(`${theme.routes.cartChange}`, {
      ...fetchConfig(),
      body: JSON.stringify(cartItem),
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (parsedState.errors) {
          this.updateErrorLiveRegions(line, parsedState.errors);
        }
        this.getSectionsToRender().forEach((section) => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace =
              element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          }
        });

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name)
          lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: {
              cart: parsedState,
            },
          })
        );
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = window.cartStrings.error;
        }
      });

    if (window.isES && freeGiftVariantId) {
      setTimeout(() => {
        this.addFreeGift(line, freeGiftVariantId);
      }, 300);
    };
  }

  addFreeGift(line, freeGiftVariantId) {
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map((section) => section.section);
    console.log(freeGiftVariantId);
    
    
    if (window.isES && freeGiftVariantId) {
      
        let freeItem = {
        'id': freeGiftVariantId,
        'quantity': 1,
        'properties': {
            '_igGWP': '1'
        },
        'sections': sections,
        'sections_url': window.location.pathname
        };
       };
      
    
    
    fetch(`${window.routes.cart_add_url}`, { ...fetchConfig(), body: JSON.stringify(freeItem)})
 
        .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const cartFooter = document.getElementById('main-cart-footer');
 
        
        this.getSectionsToRender().forEach((section => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace = element.querySelector(section.selector) || element;
 
            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }
        }));
 
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
 
        this.updateQuantityLiveRegions(line, parsedState.item_count);
        
        
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: parsedState
              }
            }));
        })
        .catch(() => {
          this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
          this.closest('cart-items').disableLoading();
          if (this.cartErrors) {
            this.cartErrors.textContent = window.cartStrings.error;
          }
        });
  }

  updateErrorLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
  
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
  
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  
  updateQuantityLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          ); 
      }
    }

    this.currentItemCount = itemCount;
    
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1e3);
    }
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    console.log("EnableLoading called");
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }

  getFreeGiftVariantId() {
    const lineItemEls = this.querySelectorAll('.cart-item');
    let freeGiftVariantId = null;
    lineItemEls?.forEach(lineItemEl => {
      const priceFinal = lineItemEl.dataset.priceFinal;
      const variantId = lineItemEl.dataset.variantId;

      if (priceFinal !== undefined && priceFinal == 0 && variantId) {
        freeGiftVariantId = variantId;
      }
    });

    return freeGiftVariantId;
  }
}

customElements.define("cart-items", CartItems);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

class SubscriptionUpgrade extends HTMLElement {
  constructor() {
    super();
    //this.miniCart = document.querySelector('mini-cart');
    this.cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status");
      //document.getElementById("CartDrawer-LineItemStatus");
    this.cartErrors = document.getElementById("cart-errors");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.addEventListener("click", this.onButtonClick.bind(this));
  }
  async onButtonClick(event) {
    console.log("onButtonClick function called");
    const cartItems =
      this.closest("cart-items") || this.closest("cart-drawer-items");

    if (event.target.classList.contains("upgrade-selling-plan__button")) {
      console.log("selling plan button function called");
      const subSelect = event.target;
      const sellingPlan = subSelect.getAttribute("data-selling-plan");
      const variantId = subSelect.getAttribute("data-variant-id");
      const line = subSelect.getAttribute("data-index");
      const key = subSelect.getAttribute("data-item-key");
      const freeGiftVariantId = subSelect.getAttribute(
        "data-free-gift-variant-id"
      );

      const parsedState = await this.updateCart(line, variantId, sellingPlan, freeGiftVariantId || cartItems.getFreeGiftVariantId(), key);

      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: {
            cart: parsedState,
          },
        })
      );
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items",
        cartData: parsedState,
      });

      //setTimeout(() => {
      //  cartItems.replaceCartItem(key, 0);
      //  //console.log('update current item to 0 to replace function called');
      //}, 500);
    }
  }

  async updateCart(line, variantId, sellingPlan, freeGiftVariantId, oldItemKey) {
    const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
    cartItems.enableLoading(line);
    this.setAttribute('disabled', true);
    this.classList.add("loading");
    //const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];
    const sections = cartItems
      .getSectionsToRender()
      .map((section) => section.section);
    if (variantId) {
      if (sellingPlan === null) {
        sellingPlan = null;
      }

      let cartItem = {
        items: [
          {
            id: variantId,
            quantity: 1,
            selling_plan: sellingPlan,
          },
        ],
        sections: sections,
        sections_url: window.location.pathname,
      };

      if (window.isES && freeGiftVariantId) {
        cartItem.items.push({
          id: freeGiftVariantId,
          quantity: 1,
          properties: {
            _igGWP: "1",
          },
        });
      }

      try {
        if (oldItemKey) {
          await cartItems.replaceCartItem(oldItemKey, 0);
          console.log('update current item to 0 to replace function called');
        }

        const response = await fetch(`${theme.routes.cartAdd}`, {
          ...fetchConfig(),
          body: JSON.stringify(cartItem),
        });
        const parsedState = await response.json();

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: parsedState,
            },
          })
        );
        return parsedState;
      } catch(e) {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        //this.closest("cart-items").disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = window.cartStrings.error;
        }
      }
    }
  }
}
customElements.define("subscription-upgrade", SubscriptionUpgrade);

class VariantSelect extends HTMLElement {
  constructor() {
    super();
    //this.miniCart = document.querySelector('mini-cart');
    this.cartItems = document.querySelector('cart-items');

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");
    this.cartErrors = document.getElementById("cart-errors");

    this.addEventListener("change", this.onVariantSelect.bind(this));
  }

  async onVariantSelect(event) {
    event.preventDefault();
    console.log("onvariant select");

    const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
    const variantSelect = event.target;
    const variantId = variantSelect.options[variantSelect.selectedIndex].value;
    const sellingPlan =
      variantSelect.options[variantSelect.selectedIndex].getAttribute(
        "data-selling-plan"
      );
    const line = variantSelect.getAttribute("data-index");
    const key = variantSelect.getAttribute("data-item-key");
    const freeGiftVariantId = variantSelect.options[
      variantSelect.selectedIndex
    ].getAttribute("data-free-gift-variant-id");

    //this.handleVariantSelection(variantSelect);
    const parsedState = await this.updateCart(line, variantId, sellingPlan, freeGiftVariantId || cartItems.getFreeGiftVariantId(), key);
    console.log("onvariant select");

    document.dispatchEvent(
      new CustomEvent("cart:updated", {
        detail: {
          cart: parsedState,
        },
      })
    );
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: "cart-items",
      cartData: parsedState,
    });
  }

  async updateCart(line, variantId, sellingPlan, freeGiftVariantId, oldItemKey) {
    const cartItems =
      this.closest("cart-items") || this.closest("cart-drawer-items");

    cartItems.enableLoading(line);
    //this.setAttribute('disabled', true);
    this.classList.add('loading');
    //const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];
    const sections = cartItems
      .getSectionsToRender()
      .map((section) => section.section);
    if (variantId) {
      if (sellingPlan === null) {
        sellingPlan = null;
      }

      let cartItem = {
        items: [
          {
            line: line,
            id: variantId,
            quantity: 1,
            selling_plan: sellingPlan,
          },
        ],
        sections: sections,
        sections_url: window.location.pathname,
      };

      if (window.isES && freeGiftVariantId) {
        cartItem.items.push({
          id: freeGiftVariantId,
          quantity: 1,
          properties: {
            _igGWP: "1",
          },
        });
      }

      try {
        if (oldItemKey) {
          await cartItems.replaceCartItem(oldItemKey, 0);
          console.log('update current item to 0 to replace function called');
        }

        const response = await fetch(`${theme.routes.cartAdd}`, {
          ...fetchConfig(),
          body: JSON.stringify(cartItem),
        });
        const parsedState = await response.json();

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: parsedState,
            },
          })
        );
        return parsedState;
      } catch(e) {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        //this.closest("cart-items").disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = window.cartStrings.error;
        }
      }
    }
  }
}

customElements.define("variant-select", VariantSelect);

class RecommendationSelect extends HTMLElement {
  constructor() {
    super();
    //this.miniCart = document.querySelector('cart-drawer-items') ||  ;
    this.cartItems =
      this.closest("cart-items") || this.closest("cart-drawer-items");

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");
    this.cartErrors = document.getElementById("cart-errors");
    this.addEventListener("change", this.onRecommendationSelect.bind(this));
  }
  onRecommendationSelect(event) {
    event.preventDefault();
    console.log("onvariant select");
    const recommendationSelect = event.target;
    const variantId =
      recommendationSelect.options[
        recommendationSelect.selectedIndex
      ].getAttribute("data-variant-id");
    console.log("variant change", variantId);

    if (variantId) {
      if (
        document.body.classList.contains("template-cart") ||
        !window.shopSettings.cartDrawer
      ) {
        Shopify.postLink(window.routes.cart_add_url, {
          parameters: {
            id: variantId,
            quantity: 1,
          },
        });
        return;
      }

      this.setAttribute("disabled", true);
      this.querySelector("select").closest(".button").classList.add("loading");
      const sections = this.miniCart
        ? this.miniCart.getSectionsToRender().map((section) => section.id)
        : [];

      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname,
      });

      fetch(`${theme.routes.cartAdd}`, { ...fetchConfig("javascript"), body })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status === 422) {
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:error", {
                detail: {
                  errorMessage: parsedState.description,
                },
              })
            );
          } else {
            this.miniCart && this.miniCart.renderContents(parsedState);

            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: {
                  product: parsedState,
                },
              })
            );
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.querySelector("select")
            .closest(".button")
            .classList.remove("loading");
          this.removeAttribute("disabled");
        });
    }
  }
}
customElements.define("recommendation-select", RecommendationSelect);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported('session')) {
      this.setupDiscount();

      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount');
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define('discount-code', DiscountCode);


if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${theme.routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

document.addEventListener('cart:updated', (e) => {
  const cartDrawer = document.querySelector("cart-drawer");
  const cartItemsEl = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
  if (cartDrawer && cartItemsEl && e.detail?.cart) {
    cartDrawer.renderContents(e.detail.cart);
    cartItemsEl.disableLoading();
  }
});
